import React, { useEffect, useState } from 'react';
import "./Table.scss"
import TableHeader from '../../components/Table/TableHeader/TableHeader';
import RecordsTable from '../../components/Table/RecordsTable/RecordsTable';

import {useNavigate, useParams} from "react-router-dom";
import ModalComponent from '../../components/UI/ModalComponent/ModalComponent';
import RecordFormMain from '../../components/Record/RecordForm/RecordFormMain/RecordFormMain';

import { useSelector } from 'react-redux';
import PostService from '../../API/PostService';
import { useFetching } from '../../hooks/useFetching';

const Table = () => {
	const params = useParams()
	const navigate = useNavigate()

	const records = useSelector(state => state.recordsTable.records)
	const currentUser = useSelector(state => state.currentUser.currentUser)

	const [ currentRecordId, setCurrentRecordId ] = useState();
	const [ currentRecord, setCurrentRecord ] = useState();

	const [ showCollapsed, setShowCollapsed ] = useState(false);
	const [ currentRecordCollapsed, setCurrentRecordCollapsed ] = useState();

	const [fetchRecord] = useFetching(async (recordId) => {
		const response = await PostService.getRecordById(recordId)
		if (response.data.success && response.data.result !== false) {
			setCurrentRecord(response.data.result)
		}
	})

	useEffect(() => {
		setCurrentRecordId(params.recordId ? params.recordId : null)
		if(params.recordId && params.recordId !== currentRecordId){
			setShowCollapsed(false)
			setCurrentRecordCollapsed(null)
		}
		if(params.recordId && params.recordId !== currentRecordId){
			const record = records.find(record => Number(record.id) === Number(params.recordId))
			if(record){
				setCurrentRecord(record)
			} else {
				fetchRecord(params.recordId)
			}
		}
	}, [params.recordId, fetchRecord, records])

	const closeModalHandler = (collapse = false) => {
		if(collapse){
			setShowCollapsed(true)
			setCurrentRecordCollapsed(currentRecord)
		}

		navigate('/')
	}

	const closeCollapsed = () => {
		setShowCollapsed(false)
		setCurrentRecordCollapsed(null)
	}

	const uncollapse = () => {
		setShowCollapsed(false)
		setCurrentRecordCollapsed(null)
		navigate('/' + currentRecordCollapsed.id + '/')
	}

	return (
		<div className="table">
			{
				currentUser && currentUser.id && 
				<>
				<TableHeader/>
				<RecordsTable/>
				{currentRecordId && currentRecord &&
					<ModalComponent isOpen={true} closeHandler={closeModalHandler} isRecordModal={currentRecordId}>
						<RecordFormMain id={currentRecordId} record={currentRecord}/>
					</ModalComponent>
				}
				{
					showCollapsed && currentRecordCollapsed &&
					<div className="table-colladsed-record">
						<button className="table-colladsed-record__close" onClick={closeCollapsed}></button>
						<button className="table-colladsed-record__collapse" onClick={uncollapse}></button>
						<RecordFormMain id={currentRecordCollapsed.id} record={currentRecordCollapsed}/>
					</div>
				}
				</>
			}
		</div>
	);
};

export default Table;
